import * as itemTypes from "../items/types"

let processTypes = {
  SIGN_IN: "SIGN_IN",
  USERS_UPDATE: "USERS_UPDATE",
  USERS_ADD: "USERS_ADD",
  CHECK_USER_SESSION: "CHECK_USER_SESSION",
  RESET_USER_PASSWORD: "RESET_USER_PASSWORD",
  LOAD_USER_ROLES: "LOAD_USER_ROLES",
  LOAD_USER_LOCALES: "LOAD_USER_LOCALES",
  UPLOAD_UPDATE: "UPLOAD_UPDATE",
  CUSTOMER_SAVE: "CUSTOMER_SAVE",
  BUNDLE_SAVE: "BUNDLE_SAVE",
  CHANGE_LOAN_STATUS: "CHANGE_LOAN_STATUS",
  BATCHES_IMPORT: "BATCHES_IMPORT",
  UPDATE_LIST: "UPDATE_LIST",
  AGE_SETTING: "AGE_SETTING",
  SAVE_AGE_SETTING: "SAVE_AGE_SETTING",
  UPDATE_AGE_SETTING: "UPDATE_AGE_SETTING",
  DELETE_AGE_SETTING: "DELETE_AGE_SETTING",
  RESUBMIT_LOAN_PROCESS: "RESUBMIT_LOAN_PROCESS",
  ASSIGN_LOAN_PROCESS: "ASSGIN_LOAN_PROCESS",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  LOAD_LOAN_DETAILS_PROCESS: "LOAD_LOAN_DETAILS_PROCESS",
  GET_CUSTOMER_LOANS_PROCESS: "GET_CUSTOMER_LOANS_PROCESS",
  LOAD_QRCODE_PROCESS: "LOAD_QRCODE_PROCESS",
  UPDATE_QRCODE_PROCESS: "UPDATE_QRCODE_PROCESS",
  USERS_LOAD: 'USERS_LOAD',
  GET_BUSINESS_LOANS_PROCESS: 'GET_BUSINESS_LOANS_PROCESS',
  LOAD_LOANS_PROCESS: 'LOAD_LOANS_PROCESS',
  CHANGE_LOAN_STATUS_PROCESS: 'CHANGE_LOAN_STATUS_PROCESS',
  LAOD_BUNDLES_PROCESS: 'LAOD_BUNDLES_PROCESS',
  LAOD_CUSTOMER_PROCESS: 'LAOD_CUSTOMER_PROCESS',
  UPDATE_LOAN_GROUP_PROCESS: 'UPDATE_LOAN_GROUP_PROCESS',
  RELOAD_LOAN_PROCESS: 'RELOAD_LOAN_PROCESS',
  RELOAD_CUSTOMER_PROCESS: 'RELOAD_CUSTOMER_PROCESS',
}

Object.keys(itemTypes).forEach(item => {
  processTypes[item] = {
    ADD: item + "_ADD",
    LOAD: item + "_LOAD",
    REMOVE: item + "_REMOVE",
    UPDATE: item + "_UPDATE"
  }
})

export default processTypes



// WEBPACK FOOTER //
// ./src/redux/processes/types.js